import { Route, Routes } from 'react-router-dom';
import AdminAliments from './app/admin/aliments/page.tsx';
import Category from './app/admin/categories/id/page.tsx';
import Categories from './app/admin/categories/page.tsx';
import AdminFeedbacks from './app/admin/feedbacks/page.tsx';
import MeasurementUnit from './app/admin/measurementUnits/id/page.tsx';
import MeasurementUnits from './app/admin/measurementUnits/page.tsx';
import AdminRecipes from './app/admin/recipes/page.tsx';
import Store from './app/admin/stores/id/page.tsx';
import Stores from './app/admin/stores/page.tsx';
import Aliment from './app/aliments/id/page.tsx';
import Aliments from './app/aliments/page.tsx';
import Feedback from './app/feedback/page.tsx';
import Journal from './app/journals/page.tsx';
import JournalStatistics from './app/journalStatistics/page.tsx';
import Recipe from './app/recipes/id/page.tsx';
import Recipes from './app/recipes/page.tsx';
import SearchPage from './app/search/page.tsx';
import ChangePassword from './app/users/changePassword/page.tsx';
import Goals from './app/users/goals/page.tsx';
import JournalNames from './app/users/journalNames/page.tsx';
import Login from './app/users/login/page.tsx';
import Logout from './app/users/logout/page.tsx';
import Measurements from './app/users/measurements/page.tsx';
import Profile from './app/users/profile/page.tsx';
import Register from './app/users/register/page.tsx';
import Navigation from './components/Navigation.tsx';
import NotFound from './components/NotFound.tsx';
import ThemeComponent from './components/ThemeComponent.tsx';

function App() {
    return (
        <>
            <ThemeComponent />
            <Navigation />
            <div className="my-5 p-2 pt-3 pb-4">
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/profile/body-measurements" element={<Measurements />} />
                    <Route path="/profile/goals" element={<Goals />} />
                    <Route path="/profile/journal-names" element={<JournalNames />} />
                    <Route path="/profile/change-password" element={<ChangePassword />} />

                    <Route path="/" element={<Journal />} />
                    <Route path="/journal" element={<Journal />} />
                    <Route path="/journal/statistics" element={<JournalStatistics />} />
                    <Route path="/journal/:dateTime" element={<Journal />} />

                    <Route path="/admin/aliments" element={<AdminAliments />} />
                    <Route path="/admin/categories" element={<Categories />} />
                    <Route path="/admin/categories/:id" element={<Category />} />
                    <Route path="/admin/measurement-units" element={<MeasurementUnits />} />
                    <Route path="/admin/measurement-units/:id" element={<MeasurementUnit />} />
                    <Route path="/admin/recipes" element={<AdminRecipes />} />
                    <Route path="/admin/stores" element={<Stores />} />
                    <Route path="/admin/stores/:id" element={<Store />} />
                    <Route path="/admin/feedbacks" element={<AdminFeedbacks />} />

                    <Route path="/aliments" element={<Aliments />} />
                    <Route path="/aliments/:id" element={<Aliment />} />
                    <Route path="/recipes" element={<Recipes />} />
                    <Route path="/recipes/:id" element={<Recipe />} />
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/feedbacks/:id" element={<Feedback />} />

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
        </>
    );
}

export default App;
